import React from 'react';
import editIcon from '../img/edit.svg';

export const ru = {
  choose_file_registry: 'Загрузить реестр',

  account: 'Лицевой счет',
  invoice: 'Счет-фактура',

  registry_field_number: 'Номер',
  registry_field_account: 'Лицевой счет',
  registry_field_invoice: 'Счет-фактура',
  registry_field_amount: 'Сумма',

  account_already_exist: 'Данный лицевой счет уже есть в таблице',
  invoice_already_exist: 'Данный счет-фактура уже есть в таблице',
  registry_identifier_required:
    'Заполните номер / лицевой счет / счет-фактуру (хотя бы одно поле)',

  ACCOUNT_DOES_NOT_BELONG_TO_CUSTOMER:
    'Данный лицевой счёт не принадлежит к указанному БИН',

  registry_bin_confirmation:
    'В реестре присутствуют данные, которые не принадлежат к указанному БИН. Вы уверены, что хотите продолжить оплату?',
  INVOICE_DOES_NOT_BELONG_TO_CUSTOMER:
    'Данный номер счёта-фактуры не принадлежит указанному БИН',

  loading_recognition_header: 'Загрузка поручения',
  loading_recognition_body: 'Обработка платежного поручения...',
  loading_recognition_init:
    'Загрузка поручения. Ожидайте, Ваше платежное поручение в очереди на обработку.',
  num_format: 'Номер телефона',
  field_password: 'Пароль',
  field_logout: 'Выйти',
  field_login: 'Войти',
  corp_info: 'Общая информация',
  corp_name: 'Название компании отправителя денег',
  corp_address: 'Адрес',
  corp_bin: 'БИН отправителя денег',
  corp_phone: 'Телефон',
  corp_bank_name: 'Банк',
  corp_bic: 'БИК',
  corp_iban: 'IBAN',
  corp_numbers: 'Номера',
  corp_number: 'Номер',
  corp_account_number: 'Номер лицевого счета',
  corp_tariff: 'Тарифный план',
  corp_balance: 'Баланс',
  corp_state: 'Статус',
  documents_report: 'Отчетные документы',
  corp_file_download_error:
    'Не получилось загрузить файлы, ошибка на сервере',
  settings_email: 'Электронный адрес',
  street: 'ул.',
  block: 'блок',
  loading: 'Загрузка...',
  usage_details_title: 'Звонки, сообщения и трафик',
  usage_details_communication_title:
    'Уважаемый абонент, Детализация счета по Вашему номеру успешно выгружена. Спасибо за пользование услугой заказа детализации через my.kcell.kz.',
  usage_details_description_preamble:
    'Если Вы хотите знать, на что потрачены средства вашего мобильного счета, то в данном разделе Вы можете заказать детализацию счета.  Выберите необходимый период и Вы получите полный отчет о расходах на звонки, сообщения и другие услуги, которыми Вы пользовались. Детализация доступна за последние 90 дней.',
  usage_details_description_text:
    'Внимание! При запросе детализации, на Ваш номер будет отправлено SMS уведомление с информацией о дате и периоде выгрузки.',
  usage_details_start_period: 'Начало периода',
  usage_details_end_period: 'Конец периода',
  usage_details_output: 'Вывод',
  usage_details_email: 'по эл почте',
  usage_details_screan: 'на экран',
  usage_details_file: 'в файл',
  usage_details_file_format: 'Формат',
  usage_details_include_period: 'включительно',

  usage_details_get: 'Запросить детализацию',
  file_format: 'Формат файла',
  display: 'Вывод',
  on_screen: 'на экран',
  to_file: 'в файл',
  to_email: 'по эл почте',
  begining_of_period: 'Начало периода',
  end_of_period: 'Конец периода',
  inclusively: 'включительно',
  usage_details: 'Детализация',
  if_num_is_saved:
    'Если распределение суммы на абонентские номера указано в назначении платежного поручения, то заполнение реестра не требуется!',
  registry_saved:
    'Если все номера находятся на общем лицевом счету и в назначении платежного поручения указан любой из абонентских номеров данного лицевого счета и/ или номер счета-фактуры, то заполнение реестра не требуется!',

  month: 'Месяц',
  year: 'Год',
  date_time: 'Дата/Время',
  date: 'Дата',
  type: 'Тип',
  direction: 'Направление',
  desc: 'Описание',
  number: 'Номер',
  duration: 'Длительность',
  units: 'Единицы',
  amount: 'Стоимость',

  sum: 'Сумма',
  get: 'Запросить',
  enabled: 'Подключено',
  disabled: 'Отключено',
  enable: 'Подключить',
  disable: 'Отключить',
  roaming: 'Роуминг',
  international_calls: 'Международные звонки',
  find_label: 'Поиск',

  limit: 'Лимит',
  credit_limit: 'Кредитный лимит',
  balance: 'Баланс',
  contacts_data: 'Контактные данные',
  bonuses: 'Бонусы',
  payment_methods: 'Система оплаты',
  services: 'Услуги',
  simcard: 'SIM-карта',
  min_8_characters: 'Минимум 8 символов',
  required_field: 'Поле обязательно для заполнения',
  active: 'Активный',
  suspended: 'Заблокирован',
  postpaid: 'Кредитный',
  pia: 'Авансовый',
  manage_block: 'Управление блокировкой',
  cancel: 'Отмена',
  sim_change: 'Замена сим карты',
  sim_number: 'Номер сим карты',
  barr_number: 'Заблокировать',
  unbarr_number: 'Разблокировать',
  replace: 'Заменить',
  no_data_found: 'Данных не найдено',
  change_service: 'Изменить набор услуг',
  no_subscriber_choosen: 'Ни один абонент не был выбран',
  previous: 'Пред.',
  next: 'След.',
  connect_roaming:
    'Для корректной работы услуги "Роуминг" необходимо включить услугу "Международные звонки".',
  roaming_connected: 'Услуга «Роуминг» успешно подключена.',
  roaming_disconnected: 'Услуга «Роуминг» успешно отключена.',
  service_not_available:
    'Извините, сервис временно недоступен. Попробуйте повторить позднее.',
  already_exists_same_app:
    'Уже существует приложение с такими же данными. Обратитесь в справочный центр',
  int_calls_connected:
    'Услуга «Международные звонки» успешно подключена.',
  int_calls_disconnected:
    'Услуга «Международные звонки» успешно отключена.',
  inet_pack_connected: 'Интернет пакет успешно подключена.',
  inet_pack_disconnected: 'Интернет пакет успешно отключена.',
  connect_inet_pack: 'Подключить интернет пакет',
  inet_traffic: 'Интернет трафик',
  barred: 'Номер заблокирован.',
  unbarred: 'Номер разблокирован.',
  login_title: 'Вход в корпоративный кабинет',
  login_title_desc:
    'Хотите управлять вашими номерами? С корпоративным кабинетом это легко!',
  payment_history: 'История платежей',
  payment_history_notice:
    'Временно история платежей доступна только для лицевых счетов с кредитным методом взаиморасчета',
  download_instruction_pdf:
    'Скачать инструкцию о пользовании кабинетом (PDF)',
  download_instruction_pptx:
    'Скачать инструкцию о пользовании кабинетом (PowerPoint)',
  fa: 'Лицевой счет',
  month0: 'январь',
  month1: 'февраль',
  month2: 'март',
  month3: 'апрель',
  month4: 'май',
  month5: 'июнь',
  month6: 'июль',
  month7: 'август',
  month8: 'сентябрь',
  month9: 'октябрь',
  month10: 'ноябрь',
  month11: 'декабрь',
  report_documents: 'Отчетные документы',
  usage_details_warning:
    'В данный момент в детализации вызовов возможны некоторые неточности. В случае' +
    ' возникновения вопросов просим обращаться в службу поддержки корпоративных клиентов – 8 (727) 258-70-21',
  sim_change_success_message: 'Замена SIM карты произведена успешно.',
  debt: 'Задолженность',
  availableNums: 'Количество доступных номеров ',
  back: 'Назад к списку',
  regForm: 'Регистрационная форма',
  internet_traffic_gb: '{0} ГБ',
  internet_traffic_mb: '{0} МБ',
  internet_every_day: 'ежедневно',
  service_daily_otf: 'ежедневно {0} теңге',
  service_over: 'Қызметке қосылған трафиктің 1 МБ тарифі',
  service_otf: '{0} теңге',
  activate: 'Подключить',
  data_pack_link: 'https://www.kcell.kz/kk/product/data-packs',
  disable_inet_pack_warning:
    'Are you sure you want to end this subscription? ',
  changeSuccess: 'Done!',
  subscribeTo: 'Subscribe to',
  unsubscribeFrom: 'Unsubscribe from',
  selectProductGroup: 'Select product group',
  selectPack: 'Выбрать интернет пакет',
  last_login: 'Время последнего входа в систему : ',
  CUSTOMER_RESTRICTED: 'Извините, у вас нет доступа к счет фактуре',
  BIN_CONFIRMED: 'BIN confirmed',
  BIN_NOT_CONFIRMED: 'BIN not confirmed',
  PAYMENT_PERMITTED_FOR_KCELL_BRAND_ONLY: 'Не номер Kcell',
  AVAILABLE_FOR_PAYMENT: 'Доступен для оплаты',
  download_eregitry_instruction: 'Скачать инструкцию (PDF)',
  download_eregitry_example: 'Скачать образец реестра (CSV)',
  eregister: 'Электронный реестр',
  re_registration_number:
    'Если номер был переоформлен, необходимо отправить реестр с указанием лицевого счета и платежным поручением на email@kcell.kz',
  eregister_desc:
    'Наиболее удобным способом оплаты услуг сотовой связи для юридического лица является банковский' +
    ' перевод. Если Вы производите оплату за услуги связи банковским переводом, единой суммой на несколько номеров, то для своевременного зачисления сумм на балансы абонентских номеров требуется предоставить реестр к платежному поручению, с указанием абонентских номеров и соответствующих сумм для зачисления. Для отправки реестра для зачисления сумм, воспользуйтесь специальной формой.',
  enter_feedback_details: 'Введите данные для обратной связи.',
  payment_details: 'Реквизиты платежа',
  eregistry_warning:
    'Внимание Зачисление сумм на абонентские номера производится в течение 24 часов с момента' +
    ' получения документов, за исключением выходных и праздничных дней.Если в течение вышеуказанного времени сумма не поступит на баланс абонентских номеров, просим сообщить нам по телефону: +7 727 2587021 или с мобильного: 9099',
  require_all_fiels: 'Заполните все поля',
  require_bin: 'Пожалуйста, укажите БИН',
  require_company_name: 'Пожалуйста, укажите название компании',
  require_contact_phone:
    'Пожалуйста, укажите контактный телефонный номер',
  require_email: 'Пожалуйста, укажите email',
  require_payment_account: 'Пожалуйста, укажите Расчетный счет Kcell',
  require_payment_order_number:
    'Пожалуйста, укажите № платежного поручения',
  require_payment_amount: 'Пожалуйста, укажите сумму платежа',
  require_payment_order_scan:
    'Пожалуйста, прикрепите скан платежного поручения',
  require_account_and_amount:
    'Пожалуйста, укажите номера и сумму в реестре',
  entered_bin_belongs_to_kcell:
    'Введенный БИН принадлежит компании KCELL',
  amount_do_not_much: 'Сумма не сходится',
  paymentSum_error:
    'Сумма в реестре не совпадает с суммой в платежном поручении. Пожалуйста, проверьте и загрузите реестр снова.',
  invalid_bin: 'Неверный БИН',
  require_number: 'Пожалуйста, введите номер',
  register_send_success: 'Реестр успешно отправлен',
  file_is_large: 'Файл(ы) превышает допустимые размеры',
  save: 'Сохранить',
  close: 'Закрыть',
  choose_file: 'Загрузить платежное поручение',
  choose_file_numbers: 'Загрузить реестр номеров',
  status: 'Статус',
  add: 'Добавить',
  delete: 'Удалить',
  e_registry_before_upload:
    'Перед загрузкой файл нужно сохранить в одном из следующих форматов: CSV, XLS, XLSX.',
  numbers: 'Номера',
  e_registry_numbers_desc:
    'Для удобного ввода данных Вы можете воспользоваться загрузкой реестра с помощью заранее созданного файла. Для этого вам нужно создать таблицу в Excel по шаблону:',
  send_e_registry: 'Отправить реестр',
  attention: 'Внимание',
  e_registry_upload_desc:
    'Для подтверждения платежа загрузите сканированную копию платежного документа. Если платежное поручение от сегодняшнего числа на документе должна быть печать банка или Вашей организации.',
  e_registry_upload_warning:
    'Допустимы к загрузке файлы размером не более 5 Мб в формате PDF',
  payment_details_warn:
    'Важно! Реквизиты в заявке должны совпадать с данными в платежном поручении, иначе платеж не будет зачислен.',
  payment_details_info:
    'Для автоматического заполнения полей, пожалуйста, загрузите платежное поручение с печатью банка в формате PDF. Для этого нажмите на кнопку "Загрузить платежное поручение".',
  payment_date_info:
    'Если в платежном поручении не указана дата валютирования, введите в это поле дату платежа. Если указаны обе даты, введите дату валютирования.',
  payment_sum: 'Сумма указанная в платежном поручении',
  kcell_payment_account: 'ИИК Бенефициара (расчетный счет Kcell)',
  payment_order_num: '№ платежного поручения',
  payment_date: 'Дата валютирования',
  read_payment_order_desc:
    'Для автоматического заполнения полей загрузите сканированную копию платежного документа. Для ручного заполнения полей или в случае некорректного считывания данных, нажмите кнопку "Редактировать".',
  read_payment_order_error:
    'Не удалось считать платежное поручение. Пожалуйста, воспользуйтесь кнопкой "Редактировать" для ручного заполнения полей.',
  read_payment_order: 'Считать платежное поручение',
  edit: 'Редактировать',
  yes: 'Да',
  no: 'Нет',
  bin_error: 'Проверьте корректность БИНа',
  number_already_exist: 'Данный номер уже есть в таблице',
  invalid_file_format: 'Некорректный формат файла',
  invalid_sum_in_file: 'В реестре присутствуют недопустимые суммы',
  same_numbers_in_file: 'Дублируются номера в файле',
  numbers_has_been_exceeded: 'Максимальное количество номеров - 3500',
  e_registry_send_warning:
    'Нажимая кнопку «Отправить реестр» вы подтверждаете корректность введенных параметров в реестр.',
  require_payment_date: 'Пожалуйста, укажите дату платежа',
  request_has_been_processed:
    'Заявка находится в обработке или была уже обработана',
  table_contains_error: 'Таблица содержит ошибки',
  traffic_volume: 'Объем трафика',
  MONTHLY_FEE: 'Ежемесячная абонентская плата',
  DAILY_FEE: 'Ежедневная абонентская плата',
  linkToDesc: 'Ссылка на описание',
  mb: 'МБ.',
  confirme_deactivation_of_service:
    'Просьба подтвердить отключение услуги',
  service_successfuly_activated: 'Услуга успешно подключена.',
  service_successfuly_deactivated: 'Услуга успешно отключена.',
  invoice_title: 'Счет на предоплату',
  invoice_msisdn: 'Номер телефона',
  invoice_msisdn_format:
    'Введите 11 значный номер в формате +7(7XX)XXXXXXX',
  invoice_bin: 'Введите 12 значный номер БИН',
  invoice_org_name: 'Введите наименование компании',
  invoice_address: 'Введите юридический адрес',
  invoice_payment_account: 'Введите номер расчетного счета',
  invoice_payment_amount: 'Введите сумму оплаты',
  invoice_payment_min_amount:
    'Введите сумму оплаты, минимальный платеж 100 тенге',
  invoice_service_type: 'Выберите тип сервиса',
  invoice_payment_for_equipment: 'За оборудование',
  invoice_payment_for_service: 'За услуги связи',
  invoice_payment_for_equipment_doc:
    'Авансовый платеж за оборудование',
  invoice_payment_for_service_doc:
    'Авансовый платеж за услуги сотовой связи',
  invoice_generate_pdf: 'Загрузить',
  sim_change_disable_alert: 'Услуга временно не доступна. ',
  report_docs_restricted:
    'Уважаемый абонент, в связи с адаптацией новой биллинговой системы AMDOCS, по техническим причинам налоговые счета-фактуры за период с 01.07.2016 по 31.03.2017 будут предоставлены Вам в индивидуальном порядке при обращении на  электронный адрес email@kcell.kz. Приносим извинения за временные неудобства.',
  disabled_handbook_description: (
    <div className="service-description">
      <p>
        Мобильный справочник – справочник контактов ваших сотрудников
        в кармане. Услуга доступна для корпоративных клиентов
        (юридических лиц и индивидуальных предпринимателей),
        являющихся абонентами Kcell как с кредитным, так и с авансовым
        порядком расчетов. Путем бесплатного смс запроса любой из
        сотрудников мгновенно получает информацию о своем коллеге.
      </p>
      <br />
      <p>
        Мобильный справочник может помочь оперативно решить такие
        рабочие проблемы как:
        <ul>
          <li>
            {' '}
            Узнать номер коллеги, который опаздывает на собрание
          </li>
          <li>
            Узнать по номеру машины кто из коллег заблокировал вас на
            парковке
          </li>
          <li>Узнать ФИО и должность звонившего вам абонента</li>
        </ul>
      </p>
      <p>
        Управлять услугой легко и просто с вашего личного кабинета
        путем нажатия нескольких кнопок. У вас также есть возможность
        разделить ваших сотрудников на две категории, и категорию VIP
        оставить невидимой для остальных сотрудников, а VIP в свою
        очередь будет видеть информацию по любому сотруднику. В рамках
        услуги вам также предоставляется бесплатный идентификатор
        4040.
      </p>
      <br />
      <p>
        Подробнее можно узнать у вашего представителя по работе с
        клиентами «Кселл» или по номеру 9099 с мобильного телефона, а
        так же (727) 258 70 21 с городского.
      </p>
    </div>
  ),
  enabled_handbook_description: (
    <div className="service-description">
      <p>
        Добро пожаловать в личный кабинет по услуге «Мобильный
        справочник». Вы можете управлять списками самостоятельно путем
        нескольких простых действий.
      </p>
      <br />
      <p>
        В таблице ниже вы можете загрузить, удалить, отредактировать
        данные по вашим сотрудникам. Также для вашего удобства вы
        можете полностью обновить список или дополнить его путем
        загрузки excel документа.
      </p>
      <br />
      <p>
        Для того чтобы внести небольшие изменения вам достаточно
        навести курсор на необходимое для вас поле и внести их.
      </p>
      <br />
      <p>
        Для внесения первоначальных данных или добавления большого
        количества полей, для вашего удобства необходимо произвести
        следующие шаги:
        <ol>
          <li>Выгрузить excel файл</li>
          <li>
            Внести в поля выгруженного файла необходимую информацию
          </li>
          <li> Загрузить excel файл</li>
        </ol>
        После произведенных действий, система сама обновит данные.
      </p>
      <br />
      <p>
        В случае возникновения вопросо просим Вас обратиться к вашему
        представителю по работе с клиентами «Кселл» или по номеру 9099
        с мобильного телефона, а так же (727) 258 70 21 с городского.
      </p>
    </div>
  ),
  new_cabinet_info_title: 'Новый кабинет для корпоративных клиентов!',
  new_cabinet_info_text: (
    <div style={{ marginLeft: '20px' }}>
      <p>
        Для всех подключенных пользователей доступен новый Кабинет!
        Перейдите по ссылке и воспользуйтесь функцией "Забыли пароль?"
        для получения доступа.
      </p>
      <p>
        Для подключения услуги заполните заявку на фирменном бланке
        компании с печатью (
        <a href="https://static.kcell.kz/b2b/page/cabinet/application-ru.docx">
          образец заявки
        </a>
        );
      </p>
      <p>
        Отправьте отсканированную версию заявки на почту Единой Службы
        Поддержки Корпоративных Клиентов{' '}
        <a
          href="mailto:email@kcell.kz"
          rel="nofollow"
          title="Follow link"
        >
          email@kcell.kz
        </a>
        .
      </p>
      <br />
      <p className="small-text">
        <a
          target="_blank"
          href="https://static.kcell.kz/files/kcell/docs/b2b_selfcare_service_instruction.pdf"
        >
          Скачать инструкцию о пользовании кабинетом (PDF)
        </a>
        <br />
      </p>
    </div>
  ),
  old_cabinet_title:
    'Старая версия Кабинета для корпоративных клиентов',
  old_cabinet_title_info: (
    <div>
      <p>
        Уведомляем, что данная версия Кабинета для корпоративных
        абонентов будет доступна для использования до 15 августа 2018
        года включительно. С 16.08.2018 доступ к старой версии
        Кабинета будет закрыт. Для всех подключенных пользователей
        доступен новый Кабинет!
      </p>
      <p>
        Перейдите по ссылке{' '}
        <a target="_blank" href="https://cabinet.kcell.kz/">
          https://cabinet.kcell.kz
        </a>{' '}
        и воспользуйтесь функцией "Забыли пароль?"
        <br />
      </p>
    </div>
  ),
  visual_src: '/public/images/new-cabinet-visual-ru.jpg',
  training_video: 'Посмотреть обучающее видео',
  please_select_date: 'Выберите дату из календаря',
  training_video_iframe: (
    <iframe
      width="854"
      height="480"
      src="https://www.youtube.com/embed/vcGsPhRrVH4"
      frameBorder={0}
      allowFullScreen={true}
    />
  ),
  null_amount: 'Значение 0 в сумме не разрешается',
  upload_doc_success_message:
    'Проверьте, что данные считались верно и совпадают с загруженным платежным поручением. Если нет - отредактируйте поля вручную.',
  upload_doc_error_message2:
    'Не удалось считать документ. Пожалуйста, загрузите платежное поручение снова. На это у Вас есть 2 попытки, затем Вы сможете редактировать поля вручную.',
  upload_doc_error_message3: (
    <span>
      Не удалось считать документ. Пожалуйста, заполните поля вручную,
      нажав на иконку
      <img
        style={{ margin: '0px 0px 0px 5px' }}
        src={editIcon}
        alt="edit-icon"
      />
    </span>
  ),
  upload_doc_error_message1: (
    <span>
      Не удалось считать документ. Пожалуйста, загрузите платежное
      поручение снова. На это у Вас осталась 1 попытка. Вы также
      можете заполнить поля вручную, нажав на иконку
      <img
        style={{ margin: '0px 0px 0px 5px' }}
        src={editIcon}
        alt="edit-icon"
      />
    </span>
  ),

  sap_hana_migration_notice: `Уважаемые абоненты,

Информируем Вас о предстоящем переходе АО «Кселл» на новую систему учета и управления SAP HANA с 01 июля 2026 года.
В целях обеспечения своевременного зачисления платежей на лицевые счета по договорным обязательствам рекомендуем, по возможности, осуществить оплату услуг по безналичному расчету не позднее 26–28 июня 2026 года.

Данная мера направлена на минимизацию возможных задержек в обработке и зачислении платежей в период миграции на новую систему учета и управления SAP HANA, а также на этапе ее постмиграционной стабилизации. После запуска SAP HANA в эксплуатацию могут проводиться дополнительные работы по автоматизации отдельных процессов, включая обработку, идентификацию и распределение поступающих денежных средств.

Обращаем Ваше внимание, что платежи, поступившие в период миграции и сразу после запуска новой системы SAP HANA, могут обрабатываться с увеличенным сроком.

При этом все обязательства Абонентов/Клиентов по оплате считаются исполненными в соответствии с условиями договоров и требованиями законодательства Республики Казахстан, независимо от сроков внутренней обработки платежей.
Условия заключенных договоров остаются без изменений.

Благодарим за понимание и сотрудничество!
В случае возникновения вопросов Вы можете обратиться в Службу поддержки корпоративных клиентов по тел. 8 (727) 258-70-21, с моб. 9099 или на email@kcell.kz`,

  new_erp_registry_notice_intro:
    'Уважаемый клиент,\nс 01.07.2026 года добавлена возможность зачисления платежей через Электронный реестр по лицевому счету и номеру счета-фактуры.',

  new_erp_registry_notice_params:
    'Теперь в реестре можно указывать один из параметров: абонентский номер, лицевой счет или номер счета-фактуры.',

  new_erp_registry_notice_template:
    'Пожалуйста, скачайте новый образец реестра:',

  new_erp_registry_template_link: 'Скачать образец реестра (CSV)',

  new_erp_registry_notice_instruction:
    'Также обязательно ознакомьтесь с актуальной Инструкцией:',

  new_erp_registry_instruction_link: 'Скачать инструкцию (PDF)',
  check_e_registry: 'Проверить реестр',
  eregistry_video_instruction: 'Видеоинструкция',
};
